const MixinComponents = {
  computed: {
    width() {
      return this.internal_config.width;
    },
    height() {
      return this.internal_config.height;
    },
    border() {
      return this.internal_config.border;
    },
    radius() {
      return this.internal_config.borderRadius;
    },
    boxShadow() {
      return this.internal_config.boxShadow;
    },
  },
  methods: {
    animation() {
      return false;
    },

    handler: function (e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);

      e.stopPropagation();
      e.preventDefault();
    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
  }
};

export default MixinComponents;



// WEBPACK FOOTER //
// ./src/js/mixins/MixinComponents.js